// extracted by mini-css-extract-plugin
export var blue = "_18-f";
export var brand = "_18-b";
export var darkGrey = "_18-e";
export var disabled = "_18-4";
export var disabledSubtle = "_18-5";
export var error = "_18-6";
export var green = "_18-g";
export var grey = "_18-d";
export var icon = "_18-0";
export var inherit = "_18-a";
export var lightGrey = "_18-c";
export var orange = "_18-i";
export var pink = "_18-k";
export var primary = "_18-1";
export var purple = "_18-l";
export var red = "_18-j";
export var secondary = "_18-2";
export var success = "_18-9";
export var tertiary = "_18-3";
export var warning = "_18-7";
export var warningSecondary = "_18-8";
export var white = "_18-m";
export var yellow = "_18-h";